import { DatePicker, Select } from 'common/InputForm';
import NotFound from 'common/NotFound';
import useDebounce from 'common/UseDebounce';
import useFullPageLoader from 'common/UseFullPageLoader';
import { SearchBar } from 'components/form';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useEffect, useState } from 'react'
import Pagination from 'react-js-pagination';
import { useSearchParams } from 'react-router-dom';
import { downloadPaymentFileApi, paymentListApi } from 'services/tramsaction';
import { dateFormat } from 'utils/dateFormat';
import findSerialNumber from 'utils/findSerialNumber';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const PaymentList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const [paymentList, setPaymentList] = useState([])
    const activePage = +searchParams.get("page") || 1;
    const search = searchParams.get("search") || ''
    const debouncedValue = useDebounce(search, 300);
    const [input, setInput] = useState({ from: '', to: '' })
    const [total, setTotal] = useState(0)
    const [totalAmount, setTotalAmount] = useState(0)
    const [buttonLoader, setButtonLoader] = useButtonLoader("Export as CSV");


    // console.log('input', input)
    //------------Handel-Pagination------------ 
    const handlePageChange = (event) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", event);
        setSearchParams(newParams);
    };
    // ----------handle-search-------------
    const handleSearch = (e) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("search", e.target.value);
        newParams.set("page", 1);
        setSearchParams(newParams);
    }
    // ----------handle-payment-mode-------------
    const handlePaymentMode = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value })
    }
    // ----------handle-date-change-------------
    const handleDateChange = (name, value) => {
        const formatDate = value
        setInput({ ...input, [name]: formatDate })
    }
    // ----------Listing-API-------------------
    useEffect(() => {
        const fetchTransactionList = async () => {
            const query = {
                page: activePage || '',
                search: debouncedValue || '',
                startDate: input.from || '',
                endDate: input.to || '',
            };
            onShow();
            try {
                const res = await paymentListApi(query);
                const { code, data } = res?.data;
                if (code === 200) {
                    setPaymentList(data?.data || []);
                    setTotal(data?.total || 0)
                    setTotalAmount(data?.totalAmount)
                }
            } catch (error) {
                console.log(error);
            } finally {
                onHide();
            }
        };
        fetchTransactionList();
    }, [activePage, debouncedValue, input.from, input.to]);

    // -----------download-File-Api----------------
    const downloadFileHandler1 = async () => {
        try {
            setButtonLoader(true);
            const param = {
                page: activePage || '',
                search: debouncedValue || '',
                from: input.from || '',
                to: input.to || '',
                // limit,
            };
            const response = await downloadPaymentFileApi(param);
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'payment.xlsx'); // Change filename as needed
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (error) {
            console.log("Download user file error: ", error);
        } finally {
            setButtonLoader(false);
        }
    };

    const downloadFileHandler = async () => {
  try {
    setButtonLoader(true);

    const param = {
      page: activePage || "",
      search: debouncedValue || "",
      from: input.from || "",
      to: input.to || "",
    };

    const response = await downloadPaymentFileApi(param);

    if (response.status === 200) {
      // ✅ Handle both cases: parsed object OR raw string
      let apiData = [];

      const rawData = response?.data;

      if (typeof rawData === "string") {
        // API returned a string — parse it
        const parsed = JSON.parse(rawData);
        apiData = parsed?.data || [];
      } else if (Array.isArray(rawData)) {
        // API returned a direct array
        apiData = rawData;
      } else if (Array.isArray(rawData?.data)) {
        // API returned { data: [...] }
        apiData = rawData.data;
      } else {
        console.error("Unexpected response format:", rawData);
        return;
      }

      const formattedData = apiData.map((item, index) => ({
        "S.No": index + 1,
        "C. ID": item?.user?.customerId || "N/A",
        "Customer Name": item?.user?.fullName || "N/A",
        "Order ID": item?.orderId ? `#${item.orderId}` : "N/A",
        "Amount": item?.total || "N/A",
        "Payment Mode": item?.paymentMode || "N/A",
        "Transaction Date": item?.createdAt
          ? new Date(item.createdAt).toLocaleDateString("en-IN")
          : "N/A",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      worksheet["!cols"] = [
        { wch: 6 },
        { wch: 10 },
        { wch: 20 },
        { wch: 12 },
        { wch: 10 },
        { wch: 15 },
        { wch: 18 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");
      XLSX.writeFile(workbook, "Payments.xlsx");
    }

  } catch (error) {
    console.log("Download payment file error:", error);
  } finally {
    setButtonLoader(false);
  }
};
    useEffect(() => {
        if (!search) {
            searchParams.delete('search')
        }
        if (activePage === 1) {
            searchParams.delete('page')
        }
        setSearchParams(searchParams)
    }, [debouncedValue, activePage])
    return (
        <div className="user-management-container">
            <div className="page_title has_child">
                <h3>Payments Management</h3>
                <button
                    className="button"
                    type="button"
                    ref={buttonLoader}
                    onClick={downloadFileHandler}
                >
                    Export as CSV
                </button>
            </div>
            <div className="card">
                <span>Total Amount<b>: {totalAmount}</b></span>
                <div className="card">
                    <div className="product-container">
                        {loader}
                        <div className="search-type-input">
                            <div className="search_wrapper">
                                <SearchBar
                                    placeholder="Search..."//by order id
                                    onChange={handleSearch}
                                    value={search}
                                />

                                <div >
                                    <DatePicker
                                        name="from"
                                        selected={input?.from}
                                        placeholder="From Date"
                                        isClearable
                                        onChange={(date) => handleDateChange('from', date)}
                                    />
                                </div>
                                <div >
                                    <DatePicker
                                        name="to"
                                        selected={input?.to}
                                        placeholder="To Date"
                                        isClearable
                                        onChange={(date) => handleDateChange('to', date)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="table-container">
                            <table className="table custom_table">
                                <thead>
                                    <tr>
                                        <th className="nowrap text-center">S.No</th>
                                        {/* <th className="nowrap text-center">Transaction ID</th> */}
                                        <th className="nowrap text-center">C. ID</th>
                                        <th className="nowrap text-center">Customer Name</th>
                                        <th className="nowrap text-center">Order ID</th>
                                        <th className="nowrap text-center">Amount</th>
                                        <th className="nowrap text-center">Payment Mode</th>
                                                                                <th className="nowrap text-center">Payment Status</th>

                                        <th className="nowrap text-center">Transaction date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paymentList && paymentList.length > 0 ? (
                                        paymentList?.map((data, ind) => {
                                            return (
                                                <tr key={ind}>
                                                    <td className="nowrap text-center">
                                                        {findSerialNumber(ind, activePage, 10)}
                                                    </td>
                                                    {/* <td className="nowrap text-center">
                                                        {data?.transactionId || "N/A"}
                                                    </td> */}
                                                    <td className="nowrap text-center">
                                                        {data?.user?.customerId || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.user?.fullName || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.orderId ? `#${data?.orderId}` : "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.total || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.paymentMode || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {/* {data?.paymentStatus || "N/A"} */}
{/* 
                                                    {data?.paymentMode === 'COD' ? 'Success' 
                                                       : data?.refundStatus === 'NOT_REQUIRED' ? 'Not Initiated': data?.refundStatus } */}
<td>
  {data?.paymentMode === 'COD'
    ? 'Success'
    : data?.refundStatus === 'NOT_REQUIRED'
      ? 'Not Initiated'
      : data?.refundStatus
          ?.toLowerCase()
          .replace(/_/g, ' ')
          .replace(/\b\w/g, c => c.toUpperCase())
  }
</td>

                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {dateFormat(data?.createdAt) || "N/A"}
                                                    </td>

                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <NotFound
                                            cols={7}
                                            msg={"Payment data not found"}
                                            onHide={onHide}
                                        />
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* -------------pagination */}
                    {total > 10 && (
                        <div className="pagination-wrapper">
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={10}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    hideDisabled={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PaymentList